export * from './final.controller';
import final from './final.html';

export { final }
